import omit from 'lodash/omit'
import metricNames from './metricNames'
import groupBy from 'lodash/groupBy'
import isString from 'lodash/isString'

export function getChannelFullName(channel) {
  if (!channel) return null

  return isString(channel)
    ? channel
    : `${channel.channelGroupId}${channel.channelId ? '/' + channel.channelId : ''}`
}

export function getConversionDataForChannel(data, channel) {
  if (!data) return null

  return Object.keys(data).reduce((acc, key) => {
    const sectionData = data[key]
    const name = getChannelFullName(channel)
    const values = sectionData[name]
    if (!values) return null
    return acc.concat(values.value)
  }, [])
}

export function groupByChannels(response) {
  return groupBy(response, item => {
    const {channel, channelGroup} = item.dimensions
    return `${channelGroup}/${channel}`
  })
}

export function processTotal(request, response) {
  if (!response) return null

  const channels = groupByChannels(response)

  return Object.keys(channels).reduce((acc, key) => {
    const data = omit(channels[key][0], ['dimensions'])
    acc[key] = Object.keys(data).reduce((obj, item) => {
      obj[metricNames[item]] = data[item]
      return obj
    }, {})
    return acc
  }, {})
}



// WEBPACK FOOTER //
// ./client/redux/modules/insights/utils.js